import {
    Chart,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    RadialLinearScale,
    ArcElement,
    Filler,
    Title,
    Tooltip,
    Legend
} from 'chart.js'
import ChartDataLabels from "chartjs-plugin-datalabels"
export default defineNuxtPlugin(() => {
    Chart.register(
        CategoryScale,
        LinearScale,
        BarElement,
        PointElement,
        LineElement,
        RadialLinearScale,
        ArcElement,
        Filler,
        Title,
        Tooltip,
        Legend,
        ChartDataLabels
    )
})